import api from './api';

let cache = null;

export async function getCompany() {
  if (cache) return cache;
  try {
    const { data } = await api.get('/settings/company');
    cache = data || {};
  } catch {
    cache = {};
  }
  return cache;
}

// Force refresh after settings update
export function clearCompanyCache() { cache = null; }

// Build the top-of-invoice header (logo on left, company info on right)
export function buildCompanyHeaderHtml(company) {
  const c = company || {};
  const logoTag = c.logo
    ? `<img src="${c.logo}" alt="logo" style="max-height:72px;max-width:120px;object-fit:contain"/>`
    : '<div style="width:72px;height:72px;border:2px dashed #E4E4E7;border-radius:8px;display:flex;align-items:center;justify-content:center;font-size:9px;color:#A1A1AA;text-align:center">No Logo</div>';
  const name = c.name
    ? `<div style="font-size:20px;font-weight:bold;color:#0A0A0A;line-height:1.2">${c.name}</div>`
    : '<div style="font-size:18px;font-weight:bold;color:#3B82F6">CSC Centre</div>';
  const addr = c.address
    ? `<div style="font-size:11px;color:#52525B;white-space:pre-line;margin-top:3px">${c.address}</div>`
    : '';
  const contact = [c.mobile && `Ph: ${c.mobile}`, c.email].filter(Boolean).join(' &nbsp;|&nbsp; ');
  const contactLine = contact
    ? `<div style="font-size:11px;color:#52525B;margin-top:2px">${contact}</div>`
    : '';
  return `
    <div style="display:flex;align-items:flex-start;justify-content:space-between;border-bottom:3px solid #3B82F6;padding-bottom:14px;margin-bottom:18px;gap:18px">
      <div style="flex-shrink:0">${logoTag}</div>
      <div style="flex:1;text-align:right">${name}${addr}${contactLine}</div>
    </div>`;
}

// Format YYYY-MM-DD or ISO into dd-mm-yyyy
export function fmtDateDMY(dateStr) {
  try {
    const d = dateStr ? new Date(dateStr) : new Date();
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    return `${dd}-${mm}-${d.getFullYear()}`;
  } catch { return dateStr || ''; }
}
